<template>
  <el-menu-item
    v-if="!items.children || items.children.length === 0"
    :style="root ? getMenuStyle : getSubMenuStyle"
    :index="index"
  >
    <div :data-id="index" :style="getMenuInnerStyle" @click.stop="clickMenuItem">
      <div class="inline anchor-icon-default" v-if="getShowIcon && getIconPosition == 'left'">
        <cxTabsIcon v-if="iconType === 'icon' && iconSrc" :iconStyle="getIconStyle" :iconSrc="iconSrc"></cxTabsIcon>
        <img v-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
      </div>
      <div class="inline anchor-icon-active" v-if="getActiveShowIcon && activeIconPosition == 'left'">
        <cxTabsIcon
          v-if="activeIconType === 'icon' && activeIconSrc"
          :iconStyle="activeIconStyle"
          :iconSrc="activeIconSrc"
        ></cxTabsIcon>
        <img v-if="activeIconType === 'img' && activeIconSrc" :src="activeIconSrc" :style="activeIconImgStyle" />
      </div>
      <span class="inline" :style="getMenuTextColor">
        <template v-if="root ? contentHasLimitwords : liContentHasLimitwords">
          {{ items.content.slice(0, root ? textLimitLines : liTextLimitLines) }}
          <template v-if="items.content.length > (root ? textLimitLines : liTextLimitLines)">...</template>
        </template>
        <span
          v-else
          :class="
            (root ? contentHasLimit && !contentHasLimitwords : liContentHasLimit && !liContentHasLimitwords)
              ? 'overflowHidMultiLines'
              : ''
          "
          :style="root ? getTextLineLimit : getLiTextLineLimit"
        >
          {{ items.content }}
        </span>
      </span>
      <div class="inline anchor-icon-default" v-if="getShowIcon && getIconPosition == 'right'">
        <cxTabsIcon v-if="iconType === 'icon' && iconSrc" :iconStyle="getIconStyle" :iconSrc="iconSrc"></cxTabsIcon>
        <img v-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
      </div>
      <div class="inline anchor-icon-active" v-if="getActiveShowIcon && activeIconPosition == 'right'">
        <cxTabsIcon
          v-if="activeIconType === 'icon' && activeIconSrc"
          :iconStyle="activeIconStyle"
          :iconSrc="activeIconSrc"
        ></cxTabsIcon>
        <img v-if="activeIconType === 'img' && activeIconSrc" :src="activeIconSrc" :style="activeIconImgStyle" />
      </div>
    </div>
  </el-menu-item>
  <el-submenu
    v-else-if="items.children && items.children.length > 0"
    :style="root ? getMenuStyle : getSubMenuStyle"
    :index="index"
  >
    <template slot="title">
      <div :data-id="index" :style="getMenuInnerStyle" @click.stop="clickMenuItem">
        <div class="inline anchor-icon-default" v-if="getShowIcon && getIconPosition == 'left'">
          <cxTabsIcon v-if="iconType === 'icon' && iconSrc" :iconStyle="getIconStyle" :iconSrc="iconSrc"></cxTabsIcon>
          <img v-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
        </div>
        <div class="inline anchor-icon-active" v-if="getActiveShowIcon && activeIconPosition == 'left'">
          <cxTabsIcon
            v-if="activeIconType === 'icon' && activeIconSrc"
            :iconStyle="activeIconStyle"
            :iconSrc="activeIconSrc"
          ></cxTabsIcon>
          <img v-if="activeIconType === 'img' && activeIconSrc" :src="activeIconSrc" :style="activeIconImgStyle" />
        </div>
        <span class="inline" :style="getMenuTextColor">
          <template v-if="root ? contentHasLimitwords : liContentHasLimitwords">
            {{ items.content.slice(0, root ? textLimitLines : liTextLimitLines) }}
            <template v-if="items.content.length > (root ? textLimitLines : liTextLimitLines)">...</template>
          </template>
          <span
            v-else
            :class="
              (root ? contentHasLimit && !contentHasLimitwords : liContentHasLimit && !liContentHasLimitwords)
                ? 'overflowHidMultiLines'
                : ''
            "
            :style="root ? getTextLineLimit : getLiTextLineLimit"
          >
            {{ items.content }}
          </span>
        </span>
        <div class="inline anchor-icon-default" v-if="getShowIcon && getIconPosition == 'right'">
          <cxTabsIcon v-if="iconType === 'icon' && iconSrc" :iconStyle="getIconStyle" :iconSrc="iconSrc"></cxTabsIcon>
          <img v-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
        </div>
        <div class="inline anchor-icon-active" v-if="getActiveShowIcon && activeIconPosition == 'right'">
          <cxTabsIcon
            v-if="activeIconType === 'icon' && activeIconSrc"
            :iconStyle="activeIconStyle"
            :iconSrc="activeIconSrc"
          ></cxTabsIcon>
          <img v-if="activeIconType === 'img' && activeIconSrc" :src="activeIconSrc" :style="activeIconImgStyle" />
        </div>
      </div>
    </template>
    <cx-menu-tree
      v-for="(child_option, child_index) in items.children"
      :key="index + '_' + child_index"
      :items="child_option"
      :index="index + '_' + child_index"
      :options="options"
      @changePath="changePath"
    />
  </el-submenu>
</template>

<script>
export default {
  name: "cx-menu-tree",
  props: {
    items: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    root: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    textLimitLines() {
      return this.options.textLimitLines
    },
    contentHasLimit() {
      return this.options.contentHasLimit
    },
    contentHasLimitwords() {
      return this.contentHasLimit && (this.options.contentHasLimitRadio == "字数" || !this.options.contentHasLimitRadio)
    },
    getTextLineLimit() {
      if (this.contentHasLimit && !this.contentHasLimitwords) {
        return {
          "-webkit-line-clamp": this.textLimitWords
        }
      } else {
        return {}
      }
    },
    textLimitWords() {
      return this.options.textLimitWords || 1
    },
    liTextLimitLines() {
      return this.options.liTextLimitLines || 4
    },
    liContentHasLimit() {
      return this.options.liContentHasLimit
    },
    liContentHasLimitwords() {
      return (
        this.liContentHasLimit &&
        (this.options.liContentHasLimitRadio == "字数" || !this.options.liContentHasLimitRadio)
      )
    },
    getLiTextLineLimit() {
      if (this.liContentHasLimit && !this.liContentHasLimitwords) {
        return {
          "-webkit-line-clamp": this.liTextLimitWords
        }
      } else {
        return {}
      }
    },
    liTextLimitWords() {
      return this.options.liTextLimitWords || 1
    },
    getPaddingStyle() {
      let padding = this.root ? `${this.options.padding}px` : `${this.options.liPadding}px`
      if (this.options.paddingTypeFlag === 2) {
        let paddingTop = this.root ? this.options.paddingTop : this.options.liPaddingTop
        let paddingRight = this.root ? this.options.paddingRight : this.options.liPaddingRight
        let paddingBottom = this.root ? this.options.paddingBottom : this.options.liPaddingBottom
        let paddingLeft = this.root ? this.options.paddingLeft : this.options.liPaddingLeft
        padding = `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`
      }
      return padding
    },
    iconSrc() {
      return (this.root ? this.options.iconSrc : this.options.liIconSrc) || ""
    },
    iconType() {
      return (this.root ? this.options.iconType : this.options.liIconType) || "img"
    },
    getIconPosition() {
      return (this.root ? this.options.iconPosition : this.options.liIconPosition) || "left"
    },
    getShowIcon() {
      return (this.root ? this.options.showIcon : this.options.liShowIcon) || false
    },
    getIconMargin() {
      let iconPosition = (this.root ? this.options.iconPosition : this.options.liIconPosition) || "left"
      let iconMargin = (this.root ? this.options.iconMargin : this.options.liIconMargin) || 0
      return iconPosition === "right"
        ? `0 0 0 ${iconMargin}px`
        : iconPosition === "left"
        ? `0 ${iconMargin}px 0 0`
        : "0 0 0 0"
    },
    getIconStyle() {
      // let iconColorIsThemeColor = this.root ? this.options.iconColorIsThemeColor : this.options.liIconColorIsThemeColor
      // let iconColor = this.root ? this.options.iconColor : this.options.liIconColor
      let iconWidth = this.root ? "iconWidth" : "liIconWidth"
      let iconHeight = this.root ? "iconHeight" : "liIconHeight"
      return {
        display: "inline-block",
        // "--color": iconColorIsThemeColor ? this.themeColor : iconColor && iconColor.color ? iconColor.color : iconColor,
        "--color":  this.root ? this.$parseColor(this.options.iconColor, {isThemeColor:this.options.iconColorIsThemeColor}) : this.$parseColor(this.options.liIconColor, {isThemeColor:this.options.liIconColorIsThemeColor }) ,
        width: this.options.hasOwnProperty(iconWidth) ? this.options[iconWidth] + "px" : "14px",
        height: this.options.hasOwnProperty(iconHeight) ? this.options[iconHeight] + "px" : "14px",
        margin: this.getIconMargin
      }
    },
    getIconImgStyle() {
      let iconWidth = this.root ? "iconWidth" : "liIconWidth"
      let iconHeight = this.root ? "iconHeight" : "liIconHeight"
      return {
        width: this.options.hasOwnProperty(iconWidth) ? this.options[iconWidth] + "px" : "14px",
        height: this.options.hasOwnProperty(iconHeight) ? this.options[iconHeight] + "px" : "14px",
        margin: this.getIconMargin
      }
    },
    activeIconSrc() {
      return (this.root ? this.options.activeIconSrc : this.options.liActiveIconSrc) || ""
    },
    activeIconType() {
      return (this.root ? this.options.activeIconType : this.options.liActiveIconType) || "img"
    },
    activeIconPosition() {
      return (this.root ? this.options.activeIconPosition : this.options.liActiveIconPosition) || "left"
    },
    getActiveShowIcon() {
      return (this.root ? this.options.activeShowIcon : this.options.liActiveShowIcon) || false
    },
    getActiveIconMargin() {
      let activeIconMargin = (this.root ? this.options.activeIconMargin : this.options.liActiveIconMargin) || 0
      return this.activeIconPosition === "right"
        ? `0 0 0 ${activeIconMargin}px`
        : this.activeIconPosition === "left"
        ? `0 ${activeIconMargin}px 0 0`
        : "0 0 0 0"
    },
    activeIconStyle() {
      // let iconColorIsThemeColor = this.root
      //   ? this.options.activeIconColorIsThemeColor
      //   : this.options.liActiveIconColorIsThemeColor
      // let iconColor = this.root ? this.options.activeIconColor : this.options.liActiveIconColor
      let iconWidth = this.root ? "activeIconWidth" : "liActiveIconWidth"
      let iconHeight = this.root ? "activeIconHeight" : "liActiveIconHeight"
      return {
        display: "inline-block",
        // "--color": iconColorIsThemeColor ? this.themeColor : iconColor && iconColor.color ? iconColor.color : iconColor,
        "--color":  this.root ? this.$parseColor(this.options.activeIconColor, {isThemeColor:this.options.activeIconColorIsThemeColor}) : this.$parseColor(this.options.liActiveIconColor, {isThemeColor:this.options.liActiveIconColorIsThemeColor}) ,
        width: this.options.hasOwnProperty(iconWidth) ? this.options[iconWidth] + "px" : "14px",
        height: this.options.hasOwnProperty(iconHeight) ? this.options[iconHeight] + "px" : "14px",
        margin: this.getActiveIconMargin
      }
    },
    activeIconImgStyle() {
      let iconWidth = this.root ? "activeIconWidth" : "liActiveIconWidth"
      let iconHeight = this.root ? "activeIconHeight" : "liActiveIconHeight"
      return {
        width: this.options.hasOwnProperty(iconWidth) ? this.options[iconWidth] + "px" : "14px",
        height: this.options.hasOwnProperty(iconHeight) ? this.options[iconHeight] + "px" : "14px",
        margin: this.getActiveIconMargin
      }
    },
    activeBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.activeBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("activeBgColorIsThemeColor")
              ? this.options.activeBgColorIsThemeColor
              : false,
            color: this.options.activeBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    defaultBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.defaultBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    hoverIsSameActive() {
      return this.options.hasOwnProperty("hoverIsSameActive") ? this.options.hoverIsSameActive : true
    },
    hoverBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground =
        this.hoverIsSameActive || !this.options.hoverBackground
          ? this.options.activeBackground
          : this.options.hoverBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("hoverBgColorIsThemeColor")
              ? this.options.hoverBgColorIsThemeColor
              : false,
            color: this.options.hoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    liBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.liBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    liHoverIsSameActive() {
      return this.options.hasOwnProperty("liHoverIsSameActive") ? this.options.liHoverIsSameActive : true
    },
    liHoverBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground =
        this.liHoverIsSameActive || !this.options.liHoverBgColor
          ? this.options.liActiveBgColor
          : this.options.liHoverBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("hoverBgColorIsThemeColor")
              ? this.options.hoverBgColorIsThemeColor
              : false,
            color: this.options.hoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    liActiveBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.liActiveBgColor
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("activeBgColorIsThemeColor")
              ? this.options.activeBgColorIsThemeColor
              : false,
            color: this.options.activeBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    getAnchorize() {
      let width = ""
      let widthUnit = ""
      let height = ""
      let heightUnit = ""
      const anchorWidthType = this.options.anchorWidthType
      switch (anchorWidthType) {
        case "px":
          width = this.options.anchorWidth
          widthUnit = "px"
          break
        case "自动":
          width = "auto"
          widthUnit = ""
          break
        case "%":
          width = 100
          widthUnit = "%"
          break
        default:
      }
      const anchorHeightType = this.options.anchorHeightType
      switch (anchorHeightType) {
        case "px":
          height = this.options.anchorHeight
          heightUnit = "px"
          break
        case "自动":
          height = "auto"
          heightUnit = ""
          break
        case "%":
          height = 100
          heightUnit = "%"
          break
        default:
      }
      return {
        width: width + widthUnit,
        height: height + heightUnit,
        flex: anchorWidthType == "%" ? 1 : ""
      }
    },
    sameStyle() {
      let tmpStyle = ""
      let boxShadowH = this.root ? this.options.defaultBoxShadowH : this.options.liBoxShadowH
      let boxShadowV = this.root ? this.options.defaultBoxShadowV : this.options.liBoxShadowV
      let boxShadowBlur = this.root ? this.options.defaultBoxShadowBlur : this.options.liBoxShadowBlur
      let boxShadowSpread = this.root ? this.options.defaultBoxShadowSpread : this.options.liBoxShadowSpread
      let boxShadowColor = this.root ? this.options.defaultBoxShadowColor : this.options.liBoxShadowColor
      let opacity = this.root ? this.options.anchorOpacity : this.options.liOpacity
      if (Array.isArray(boxShadowH)) {
        boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle +=
              `${boxShadowH[index]}px ${boxShadowV[index]}px ${boxShadowBlur[index]}px ${boxShadowSpread[index]}px ${this.$parseColor(boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${boxShadowH}px ${boxShadowV}px ${boxShadowBlur}px ${boxShadowSpread}px ${this.$parseColor(boxShadowColor)}`
      }
      const divideWidth = this.options.divideWidth || 1
      let divideMargin = 0
      if (this.options.marginRight !== undefined) divideMargin = -(this.options.marginRight + divideWidth) / 2
      return {
        ...this.getAnchorize,
        opacity: Number.isNaN(opacity) ? 1 : opacity / 100,
        padding: this.getPaddingStyle,
        "margin-right": this.options.marginRight + "px",
        "margin-bottom": this.options.marginBottom + "px",
        boxShadow: tmpStyle,
        "--divideMargin": divideMargin + "px"
      }
    },
    getMenuStyle() {
      let borderW = "",
        activeBorderW = "",
        hoverBorderW = "",
        actualLineHeight =
          this.options.lineHeightType === "%"
            ? (this.options.lineHeight / 100) * this.options.fontSize
            : this.options.lineHeight
      if (!this.options.showBorder) {
        borderW = "0"
      } else if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += `${item}px `)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      if (!this.options.showActiveBorder) {
        activeBorderW = "0"
      } else if (Array.isArray(this.options.activeBorderWidth)) {
        this.options.activeBorderWidth.forEach(item => [(activeBorderW += `${item}px `)])
      } else {
        activeBorderW += ` ${this.options.activeBorderWidth}px`
      }
      if (!this.options.showHoverBorder) {
        hoverBorderW = "0"
      } else if (Array.isArray(this.options.hoverBorderWidth)) {
        this.options.hoverBorderWidth.forEach(item => [(hoverBorderW += `${item}px `)])
      } else {
        hoverBorderW += ` ${this.options.hoverBorderWidth}px`
      }
      borderW = borderW.trim()
      activeBorderW = activeBorderW.trim()
      hoverBorderW = hoverBorderW.trim()
      let hoverBorderColor = this.hoverIsSameActive
          ? this.$parseColor(this.options.activeBorderColor,{isThemeColor: this.options.activeBorderIsThemeColor})
          :  this.$parseColor(this.options.hoverBorderColor,{isThemeColor: this.options.hoverBorderIsThemeColor})
      let hoverBackground = this.hoverIsSameActive
          ? this.$parseColor(this.options.activeBgColor,{isThemeColor: this.options.activeBgIsThemeColor})
          :  this.$parseColor(this.options.hoverBgColor,{isThemeColor: this.options.hoverBgIsThemeColor})
      let actualActiveLineHeight =
        this.options.activeLineHeightType === "%"
          ? (this.options.activeLineHeight / 100) * this.options.activeFontSize
          : this.options.activeLineHeight
      let actualHoverLineHeight =
        this.options.hoverLineHeightType === "%"
          ? (this.options.hoverLineHeight / 100) * this.options.hoverFontSize
          : this.options.hoverLineHeight
      let bg = {
        "--backgroundImage": this.defaultBgStyle?.backgroundImage,
        "--backgroundSize": this.defaultBgStyle?.backgroundSize,
        "--backgroundPosition": this.defaultBgStyle?.backgroundPosition,
        "--backgroundRepeat": this.defaultBgStyle?.backgroundRepeat,
        "--backgroundColor": this.defaultBgStyle? this.$parseColor(this.defaultBgStyle.backgroundColor) : ''
      }
      let hoverBg = {
        "--hoverBackgroundImage": this.hoverBgStyle?.backgroundImage,
        "--hoverBackgroundSize": this.hoverBgStyle?.backgroundSize,
        "--hoverBackgroundPosition": this.hoverBgStyle?.backgroundPosition,
        "--hoverBackgroundRepeat": this.hoverBgStyle?.backgroundRepeat,
        "--hoverBackgroundColor": this.hoverBgStyle? this.$parseColor(this.hoverBgStyle.backgroundColor) : ''
      }
      let activeBg = {
        "--activeBackgroundImage": this.activeBgStyle?.backgroundImage,
        "--activeBackgroundSize": this.activeBgStyle?.backgroundSize,
        "--activeBackgroundPosition": this.activeBgStyle?.backgroundPosition,
        "--activeBackgroundRepeat": this.activeBgStyle?.backgroundRepeat,
        "--activeBackgroundColor": this.activeBgStyle? this.$parseColor(this.activeBgStyle.backgroundColor) : ''
      }
      return {
        ...bg,
        ...hoverBg,
        ...activeBg,
        "--lineHeight": actualLineHeight + "px",
        "--itemHeight": this.getAnchorize.height,
        "--itemWidth": this.getAnchorize.width,
        "--fontWeight": this.options.fontWeight,
        "--fontSize": this.options.fontSize + "px",
        "--fontFamily": this.options.fontFamily,
        "--textAlign": this.options.textAlign,
        "--writingMode": this.options.writingMode,
        "--letterSpacing": this.options.letterSpacing + "px",
        "--textDecoration": this.options.textDecoration,
        "--fontStyle": this.options.fontStyle,
        "--borderRadius": `${this.options.borderTopLeftRadius}px ${this.options.borderTopRightRadius}px ${this.options.borderBottomRightRadius}px ${this.options.borderBottomLeftRadius}px`,
        "--borderStyle": this.options.borderStyle,
        "--borderColor": this.$parseColor(this.options.borderColor,{isThemeColor: this.options.borderIsThemeColor}),
        "--borderWidth": borderW,
        "--boxShadow": this.sameStyle.boxShadow,
        "--activeBorderWidth": activeBorderW,
        "--activeBorderStyle": this.options.activeBorderStyle,
        "--activeBorderColor": this.$parseColor(this.options.activeBorderColor,{isThemeColor: this.options.activeBorderIsThemeColor}),
        "--activeBorderRadius": `${this.options.activeBorderTopLeftRadius}px ${this.options.activeBorderTopRightRadius}px ${this.options.activeBorderBottomRightRadius}px ${this.options.activeBorderBottomLeftRadius}px`,
        "--activeFontWeight": this.options.activeFontWeight,
        "--activeFontSize": this.options.activeFontSize + "px",
        "--activeFontFamily": this.options.activeFontFamily,
        "--activeTextAlign": this.options.activeTextAlign,
        "--activeLineHeight": actualActiveLineHeight + "px",
        "--activeWritingMode": this.options.activeWritingMode,
        "--activeLetterSpacing": this.options.activeLetterSpacing + "px",
        "--activeTextDecoration": this.options.activeTextDecoration,
        "--activeFontStyle": this.options.activeFontStyle,
        "--hoverBorderColor": hoverBorderColor,
        "--hoverBorderRadius": this.hoverIsSameActive
          ? `${this.options.activeBorderTopLeftRadius}px ${this.options.activeBorderTopRightRadius}px ${this.options.activeBorderBottomRightRadius}px ${this.options.activeBorderBottomLeftRadius}px`
          : `${this.options.hoverBorderTopLeftRadius}px ${this.options.hoverBorderTopRightRadius}px ${this.options.hoverBorderBottomRightRadius}px ${this.options.hoverBorderBottomLeftRadius}px`,
        "--hoverBorderWidth": this.hoverIsSameActive ? activeBorderW : hoverBorderW,
        "--hoverBorderStyle": this.hoverIsSameActive ? this.options.activeBorderStyle : this.options.hoverBorderStyle,
        "--hoverFontWeight": this.hoverIsSameActive ? this.options.activeFontWeight : this.options.hoverFontWeight,
        "--hoverFontSize": this.hoverIsSameActive
          ? this.options.activeFontSize + "px"
          : this.options.hoverFontSize + "px",
        "--hoverFontFamily": this.hoverIsSameActive ? this.options.activeFontFamily : this.options.hoverFontFamily,
        "--hoverTextAlign": this.hoverIsSameActive ? this.options.activeTextAlign : this.options.hoverTextAlign,
        "--hoverLineHeight": this.hoverIsSameActive ? actualActiveLineHeight + "px" : actualHoverLineHeight + "px",
        "--hoverWritingMode": this.hoverIsSameActive ? this.options.activeWritingMode : this.options.hoverWritingMode,
        "--hoverLetterSpacing": this.hoverIsSameActive
          ? this.options.activeLetterSpacing + "px"
          : this.options.hoverLetterSpacing + "px",
        "--hoverTextDecoration": this.hoverIsSameActive
          ? this.options.activeTextDecoration
          : this.options.hoverTextDecoration,
        "--hoverFontStyle": this.hoverIsSameActive ? this.options.activeFontStyle : this.options.hoverFontStyle,
        "--leftIndent": this.options.indent + "px",
        "--hoverBackground": hoverBackground
      }
    },
    getSubMenuStyle() {
      let borderW = "",
        activeBorderW = "",
        hoverBorderW = "",
        actualLineHeight =
          this.options.liLineHeightType === "%"
            ? (this.options.liLineHeight / 100) * this.options.liFontSize
            : this.options.liLineHeight
      if (!this.options.liShowBorder) {
        borderW = "0"
      } else if (Array.isArray(this.options.liBorderWidth)) {
        this.options.liBorderWidth.forEach(item => [(borderW += `${item}px `)])
      } else {
        borderW += ` ${this.options.liBorderWidth}px`
      }
      if (!this.options.liActiveShowBorder) {
        activeBorderW = "0"
      } else if (Array.isArray(this.options.liActiveBorderWidth)) {
        this.options.liActiveBorderWidth.forEach(item => [(activeBorderW += `${item}px `)])
      } else {
        activeBorderW += ` ${this.options.liActiveBorderWidth}px`
      }
      if (!this.options.liHoverShowBorder) {
        hoverBorderW = "0"
      } else if (Array.isArray(this.options.liHoverBorderWidth)) {
        this.options.liHoverBorderWidth.forEach(item => [(hoverBorderW += `${item}px `)])
      } else {
        hoverBorderW += ` ${this.options.liHoverBorderWidth}px`
      }
      borderW = borderW.trim()
      activeBorderW = activeBorderW.trim()
      hoverBorderW = hoverBorderW.trim()
      let hoverBorderColor = this.liHoverIsSameActive?
          this.$parseColor(this.options.liActiveBorderColor,{isThemeColor: this.options.liActiveBorderIsThemeColor}) :
          this.$parseColor(this.options.liHoverBorderColor,{isThemeColor: this.options.hoverBorderIsThemeColor})
      let actualActiveLineHeight =
        this.options.liActiveLineHeightType === "%"
          ? (this.options.liActiveLineHeight / 100) * this.options.liActiveFontSize
          : this.options.liActiveLineHeight
      let actualHoverLineHeight =
        this.options.liHoverLineHeightType === "%"
          ? (this.options.liHoverLineHeight / 100) * this.options.liHoverFontSize
          : this.options.liHoverLineHeight
      let bg = {
        "--backgroundImage": this.liBgStyle?.backgroundImage,
        "--backgroundSize": this.liBgStyle?.backgroundSize,
        "--backgroundPosition": this.liBgStyle?.backgroundPosition,
        "--backgroundRepeat": this.liBgStyle?.backgroundRepeat,
        "--backgroundColor": this.liBgStyle? this.$parseColor(this.liBgStyle.backgroundColor) :''
      }
      let hoverBg = {
        "--hoverBackgroundImage": this.liHoverBgStyle?.backgroundImage,
        "--hoverBackgroundSize": this.liHoverBgStyle?.backgroundSize,
        "--hoverBackgroundPosition": this.liHoverBgStyle?.backgroundPosition,
        "--hoverBackgroundRepeat": this.liHoverBgStyle?.backgroundRepeat,
        "--hoverBackgroundColor": this.liHoverBgStyle?this.$parseColor(this.liHoverBgStyle.backgroundColor) :''
      }
      let activeBg = {
        "--activeBackgroundImage": this.liActiveBgStyle?.backgroundImage,
        "--activeBackgroundSize": this.liActiveBgStyle?.backgroundSize,
        "--activeBackgroundPosition": this.liActiveBgStyle?.backgroundPosition,
        "--activeBackgroundRepeat": this.liActiveBgStyle?.backgroundRepeat,
        "--activeBackgroundColor": this.liActiveBgStyle?this.$parseColor(this.liActiveBgStyle.backgroundColor) :''
      }
      return {
        ...bg,
        ...hoverBg,
        ...activeBg,
        "--lineHeight": actualLineHeight + "px",
        "--itemHeight": this.getAnchorize.height,
        "--itemWidth": this.getAnchorize.width,
        "--fontWeight": this.options.liFontWeight,
        "--fontSize": this.options.liFontSize + "px",
        "--fontFamily": this.options.liFontFamily,
        "--textAlign": this.options.liTextAlign,
        "--writingMode": this.options.liWritingMode,
        "--letterSpacing": this.options.liLetterSpacing + "px",
        "--textDecoration": this.options.liTextDecoration,
        "--fontStyle": this.options.liFontStyle,
        "--borderRadius": `${this.options.liBorderTopLeftRadius}px ${this.options.liBorderTopRightRadius}px ${this.options.liBorderBottomRightRadius}px ${this.options.liBorderBottomLeftRadius}px`,
        "--borderStyle": this.options.liBorderStyle,
        "--borderColor": this.$parseColor(this.options.liBorderColor,{isThemeColor: this.options.liBorderIsThemeColor}),
        "--borderWidth": borderW,
        "--boxShadow": this.sameStyle.boxShadow,
        "--activeBorderWidth": activeBorderW,
        "--activeBorderStyle": this.options.liActiveBorderStyle,
        "--activeBorderColor": this.$parseColor(this.options.liActiveBorderColor,{isThemeColor: this.options.liActiveBorderIsThemeColor}),
        "--activeBorderRadius": `${this.options.liActiveBorderTopLeftRadius}px ${this.options.liActiveBorderTopRightRadius}px ${this.options.liActiveBorderBottomRightRadius}px ${this.options.liActiveBorderBottomLeftRadius}px`,
        "--activeFontWeight": this.options.liActiveFontWeight,
        "--activeFontSize": this.options.liActiveFontSize + "px",
        "--activeFontFamily": this.options.liActiveFontFamily,
        "--activeTextAlign": this.options.liActiveTextAlign,
        "--activeLineHeight": actualActiveLineHeight + "px",
        "--activeWritingMode": this.options.liActiveWritingMode,
        "--activeLetterSpacing": this.options.liActiveLetterSpacing + "px",
        "--activeTextDecoration": this.options.liActiveTextDecoration,
        "--activeFontStyle": this.options.liActiveFontStyle,
        "--hoverBorderColor": hoverBorderColor,
        "--hoverBorderRadius": this.liHoverIsSameActive
          ? `${this.options.liActiveBorderTopLeftRadius}px ${this.options.liActiveBorderTopRightRadius}px ${this.options.liActiveBorderBottomRightRadius}px ${this.options.liActiveBorderBottomLeftRadius}px`
          : `${this.options.liHoverBorderTopLeftRadius}px ${this.options.liHoverBorderTopRightRadius}px ${this.options.liHoverBorderBottomRightRadius}px ${this.options.liHoverBorderBottomLeftRadius}px`,
        "--hoverBorderWidth": this.liHoverIsSameActive ? activeBorderW : hoverBorderW,
        "--hoverBorderStyle": this.liHoverIsSameActive
          ? this.options.liActiveBorderStyle
          : this.options.liHoverBorderStyle,
        "--hoverFontWeight": this.liHoverIsSameActive
          ? this.options.liActiveFontWeight
          : this.options.liHoverFontWeight,
        "--hoverFontSize": this.liHoverIsSameActive
          ? this.options.liActiveFontSize + "px"
          : this.options.liHoverFontSize + "px",
        "--hoverFontFamily": this.liHoverIsSameActive
          ? this.options.liActiveFontFamily
          : this.options.liHoverFontFamily,
        "--hoverTextAlign": this.liHoverIsSameActive ? this.options.liActiveTextAlign : this.options.liHoverTextAlign,
        "--hoverLineHeight": this.liHoverIsSameActive ? actualActiveLineHeight + "px" : actualHoverLineHeight + "px",
        "--hoverWritingMode": this.liHoverIsSameActive
          ? this.options.liActiveWritingMode
          : this.options.liHoverWritingMode,
        "--hoverLetterSpacing": this.liHoverIsSameActive
          ? this.options.liActiveLetterSpacing + "px"
          : this.options.liHoverLetterSpacing + "px",
        "--hoverTextDecoration": this.liHoverIsSameActive
          ? this.options.liActiveTextDecoration
          : this.options.liHoverTextDecoration,
        "--hoverFontStyle": this.liHoverIsSameActive ? this.options.liActiveFontStyle : this.options.liHoverFontStyle,
        "--leftIndent": this.options.indent + "px"
      }
    },
    getMenuInnerStyle() {
      let opacity = this.root ? this.options.anchorOpacity : this.options.liOpacity
      return {
        padding: this.getPaddingStyle,
        opacity: (typeof opacity === "number" ? opacity : 100) / 100
      }
    },
    getMenuTextColor() {
      let colorName = this.root ? "color" : "liFontColor"
      let colorIsThemeColor = this.root ? "textIsThemeColor" : "liTextIsThemeColor"
      let hoverColorName = this.root ? "hoverColor" : "liHoverFontColor"
      let hoverColorIsThemeColor = this.root ? "hoverTextIsThemeColor" : "liHoverTextIsThemeColor"
      let activeColorName = this.root ? "activeColor" : "liActiveFontColor"
      let activeColorIsThemeColor = this.root ? "activeTextIsThemeColor" : "liActiveTextIsThemeColor"
      let hoverIsSameActive = this.root ? "hoverIsSameActive" : "liHoverIsSameActive"
      let hoverColor = {}
      let activeColor = {}
      // 激活颜色
      if(!this.options[activeColorIsThemeColor] && !this.options[activeColorName]){
        activeColor = {
          "--activeColor": "rgba(0, 0, 0, 0.8)"
        }
      }else if(this.options[activeColorName].type === "color"){
        activeColor = {
          "--activeColor": this.$parseColor(this.options[activeColorName],{isThemeColor: this.options[activeColorIsThemeColor]})
        }
      } else if(this.options[activeColorName].type === "linearGradient"){
        activeColor = {
          "--activeColor": "transparent",
          "--activeBackgroundImage": this.$parseColor(this.options[activeColorName],{isThemeColor: this.options[activeColorIsThemeColor]}),
          "-webkit-background-clip": "text"
        }
      }else if(this.options[activeColorIsThemeColor]){
        activeColor = {
          "--activeColor": this.$parseColor(this.options[activeColorName],{isThemeColor: this.options[activeColorIsThemeColor]})
        }
      }

      // if (this.options[activeColorIsThemeColor]) {
      //   activeColor = {
      //     "--activeColor": this.themeColor
      //   }
      // } else if (!this.options[activeColorName]) {
      //   activeColor = {
      //     "--activeColor": "rgba(0, 0, 0, 0.8)"
      //   }
      // } else if (this.options[activeColorName].type === "color") {
      //   activeColor = {
      //     "--activeColor": this.options[activeColorName].color
      //       ? this.options[activeColorName].color
      //       : this.options[activeColorName].data?.stops[0][0]
      //   }
      // } else if (this.options[activeColorName].type === "linearGradient") {
      //   //老数据兼容 有些colorArr.data.stops不是数组
      //   let tmp = []
      //   this.options[activeColorName].data.stops.forEach(item => {
      //     tmp.push(item[0] + " " + item[1] * 100 + "%")
      //   })
      //   activeColor = {
      //     "--activeColor": "transparent",
      //     "--activeBackgroundImage": `-webkit-linear-gradient(${
      //       this.options[activeColorName].data.angle
      //     }deg, ${tmp.join(",")})`,
      //     "-webkit-background-clip": "text"
      //   }
      // }

      // 悬浮颜色
      if (this[hoverIsSameActive]) {
        hoverColor = {
          "--hoverColor": activeColor["--activeColor"],
          "--hoverBackgroundImage": activeColor["--activeBackgroundImage"],
          "-webkit-background-clip": "text"
        }
      } else {
        if (!this.options[hoverColorName] && !this.options[hoverColorIsThemeColor]) {
          hoverColor = {
            "--hoverColor": "rgba(0, 0, 0, 0.8)"
          }
        } else if (this.options[hoverColorName].type === "color") {
          hoverColor = {
            "--hoverColor": this.$parseColor(this.options[hoverColorName],{isThemeColor: this.options[hoverColorIsThemeColor]}),
          }
        } else if (this.options[hoverColorName].type === "linearGradient") {
          //老数据兼容 有些colorArr.data.stops不是数组
          // let tmp = []
          // this.options[hoverColorName].data.stops.forEach(item => {
          //   tmp.push(item[0] + " " + item[1] * 100 + "%")
          // })
          hoverColor = {
            "--hoverColor": "transparent",
            "--hoverBackgroundImage": this.$parseColor(this.options[hoverColorName],{isThemeColor: this.options[hoverColorIsThemeColor]}),
            "-webkit-background-clip": "text"
          }
        }else if(this.options[hoverColorIsThemeColor]){
          hoverColor = {
            "--hoverColor": this.$parseColor(this.options[hoverColorName],{isThemeColor: this.options[hoverColorIsThemeColor]})
          }
        }
      }
      // 常规颜色
      if (!this.options[colorName] && !this.options[colorIsThemeColor]) {
        return {
          ...activeColor,
          ...hoverColor,
          color: "rgba(0, 0, 0, 0.8)"
        }
      } else if (this.options[colorName].type === "color") {
        return {
          ...activeColor,
          ...hoverColor,
          color: this.$parseColor(this.options[colorName],{isThemeColor:this.options[colorIsThemeColor]})
          // color: this.options[colorName].color
          //   ? this.options[colorName].color
          //   : this.options[colorName].data?.stops[0][0]
        }
      } else if (this.options[colorName].type === "linearGradient") {
        //老数据兼容 有些colorArr.data.stops不是数组
        // let tmp = []
        // this.options[colorName].data.stops.forEach(item => {
        //   tmp.push(item[0] + " " + item[1] * 100 + "%")
        // })
        return {
          ...activeColor,
          ...hoverColor,
          color: "transparent",
          // backgroundImage: `-webkit-linear-gradient(${this.options[colorName].data.angle}deg, ${tmp.join(",")})`,
          backgroundImage: this.$parseColor(this.options[colorName],{isThemeColor:this.options[colorIsThemeColor]}),
          "-webkit-background-clip": "text"
        }
      } else if(this.options[colorIsThemeColor]){
        return {
          ...activeColor,
          ...hoverColor,
          color:  this.$parseColor(this.options[colorName],{isThemeColor:this.options[colorIsThemeColor]})
        }
      } else {
        return {
          ...activeColor,
          ...hoverColor
        }
      }
    },
    activeIndex() {
      return this.options.activeIndex
    }
  },
  watch: {
    activeIndex: {
      immediate: true,
      handler(n) {
        // 只需要监听最顶层即可
        if (n && this.root && this.index == "0") {
          this.$nextTick(() => {
            this.updateMenuStatus()
          })
        }
      }
    }
  },
  methods: {
    clickMenuItem() {
      this.$emit("changePath", this.index)
    },
    changePath(path) {
      this.$emit("changePath", path)
    },
    updateMenuStatus() {
      const target = document.querySelectorAll(`[data-id='${this.activeIndex}']`)
      for (let i = 0; i < target.length; i++) {
        const anchorContainer = target[i].closest(".anchorContainer")
        const menuItems = anchorContainer.querySelectorAll("[role='menuitem']")
        for (let i = 0; i < menuItems.length; i++) {
          menuItems[i].classList.remove("is-active")
        }
        const menuDom = target[i].closest(".el-menu-item") || target[i].closest(".el-submenu")
        menuDom.classList.add("is-active")
      }
    }
  }
}
</script>
<style scoped>
.inline {
  display: inline-block;
  vertical-align: top;
}
.anchor-icon-active {
  display: none;
}
.overflowHidMultiLines {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
